 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1LONGEVITYLANE1 from '@/components/0_chapter1longevitylane1'
 import A_CHAPTER2LONGEVITYLANE2 from '@/components/1_chapter2longevitylane2'
 import A_CHAPTER3SNEAKER1 from '@/components/2_chapter3sneaker1'
 import A_CHAPTER4SNEAKER2 from '@/components/3_chapter4sneaker2'
 import A_CHAPTER5HOMICIDE1 from '@/components/4_chapter5homicide1'
 import A_CHAPTER6HOMICIDE2 from '@/components/5_chapter6homicide2'
 import A_CHAPTER7ENDANGERED1 from '@/components/6_chapter7endangered1'
 import A_CHAPTER8ENDANGERED2 from '@/components/7_chapter8endangered2'
 import A_CHAPTER9BLOODFIGHTING1 from '@/components/8_chapter9bloodfighting1'
 import A_CHAPTER10BLOODFIGHTING2 from '@/components/9_chapter10bloodfighting2'
 import A0_CHAPTER11INITIALDISPLAYSKILL1 from '@/components/10_chapter11initialdisplayskill1'
 import A1_CHAPTER12INITIALDISPLAYSKILL2 from '@/components/11_chapter12initialdisplayskill2'
 import A2_CHAPTER13ENCOUNTERANOLDFRIEND1 from '@/components/12_chapter13encounteranoldfriend1'
 import A3_CHAPTER14ENCOUNTERANOLDFRIEND2 from '@/components/13_chapter14encounteranoldfriend2'
 import A4_CHAPTER15NETHERKARMICFIRE1 from '@/components/14_chapter15netherkarmicfire1'
 import A5_CHAPTER16NETHERKARMICFIRE2 from '@/components/15_chapter16netherkarmicfire2'
 import A6_CHAPTER17GRAVEPROTECTINGBEASTSPIRIT1 from '@/components/16_chapter17graveprotectingbeastspirit1'
 import A7_CHAPTER18GRAVEPROTECTINGBEASTSPIRIT2 from '@/components/17_chapter18graveprotectingbeastspirit2'
 import A8_CHAPTER19SPIRITUALDEFICIENCYOFTHEDAOTOMB1 from '@/components/18_chapter19spiritualdeficiencyofthedaotomb1'
 import A9_CHAPTER20SPIRITUALDEFICIENCYOFTHEDAOTOMB2 from '@/components/19_chapter20spiritualdeficiencyofthedaotomb2'
 import A0_CHAPTER21ATTHEBATTLEOFTHEVOID1 from '@/components/20_chapter21atthebattleofthevoid1'
 import A1_CHAPTER22ATTHEBATTLEOFTHEVOID2 from '@/components/21_chapter22atthebattleofthevoid2'
 import A2_CHAPTER23ABATTLEOFSPIRITSANDDEFICIENCY1 from '@/components/22_chapter23abattleofspiritsanddeficiency1'
 import A3_CHAPTER24ABATTLEOFSPIRITSANDDEFICIENCY2 from '@/components/23_chapter24abattleofspiritsanddeficiency2'
 import A4_CHAPTER25THEDAUGHTEROFAGRAVEROBBER1 from '@/components/24_chapter25thedaughterofagraverobber1'
 import A5_CHAPTER26THEDAUGHTEROFAGRAVEROBBER2 from '@/components/25_chapter26thedaughterofagraverobber2'
 import A6_CHAPTER27ANXIETYBUILDING1 from '@/components/26_chapter27anxietybuilding1'
 import A7_CHAPTER28ANXIETYBUILDING2 from '@/components/27_chapter28anxietybuilding2'
 import A8_CHAPTER29MIDNIGHTROSE1 from '@/components/28_chapter29midnightrose1'
 import A9_CHAPTER30MIDNIGHTROSE2 from '@/components/29_chapter30midnightrose2'
 import A0_CHAPTER31GOLDENHOSTTALENTSHOW1 from '@/components/30_chapter31goldenhosttalentshow1'
 import A1_CHAPTER32GOLDENHOSTTALENTSHOW2 from '@/components/31_chapter32goldenhosttalentshow2'
 import A2_CHAPTER33SURESIDENCE1 from '@/components/32_chapter33suresidence1'
 import A3_CHAPTER34SURESIDENCE2 from '@/components/33_chapter34suresidence2'
 import A4_CHAPTER35GHOSTWIFE1 from '@/components/34_chapter35ghostwife1'
 import A5_CHAPTER36GHOSTWIFE2 from '@/components/35_chapter36ghostwife2'
 import A6_CHAPTER37THEBATTLEOFTHESURESIDENCE1 from '@/components/36_chapter37thebattleofthesuresidence1'
 import A7_CHAPTER38THEBATTLEOFTHESURESIDENCE2 from '@/components/37_chapter38thebattleofthesuresidence2'
 import A8_CHAPTER39AWAKENINGOFSOUL1 from '@/components/38_chapter39awakeningofsoul1'
 import A9_CHAPTER40AWAKENINGOFSOUL2 from '@/components/39_chapter40awakeningofsoul2'
 import A0_CHAPTER41ICEANDSNOWPARADISE1 from '@/components/40_chapter41iceandsnowparadise1'
 import A1_CHAPTER42ICEANDSNOWPARADISE2 from '@/components/41_chapter42iceandsnowparadise2'
 import A2_CHAPTER43NIGHTDEMONASURA1 from '@/components/42_chapter43nightdemonasura1'
 import A3_CHAPTER44NIGHTDEMONASURA2 from '@/components/43_chapter44nightdemonasura2'
 import A4_CHAPTER45ABEASTFIGHTING1 from '@/components/44_chapter45abeastfighting1'
 import A5_CHAPTER46ABEASTFIGHTING2 from '@/components/45_chapter46abeastfighting2'
 import A6_CHAPTER47MEILANSNOWPARTI1 from '@/components/46_chapter47meilansnowparti1'
 import A7_CHAPTER48MEILANSNOWPARTI2 from '@/components/47_chapter48meilansnowparti2'
 import A8_CHAPTER49MEILANSNOWPARTII1 from '@/components/48_chapter49meilansnowpartii1'
 import A9_CHAPTER50MEILANSNOWPARTII2 from '@/components/49_chapter50meilansnowpartii2'
 import A0_CHAPTER51MEILANSNOWPARTII1 from '@/components/50_chapter51meilansnowpartii1'
 import A1_CHAPTER52MEILANSNOWPARTII2 from '@/components/51_chapter52meilansnowpartii2'
 import A2_CHAPTER53POLYGONUMCUSPIDATUMTHUNB1 from '@/components/52_chapter53polygonumcuspidatumthunb1'
 import A3_CHAPTER54POLYGONUMCUSPIDATUMTHUNB2 from '@/components/53_chapter54polygonumcuspidatumthunb2'
 import A4_CHAPTER55THECATACLYSM1 from '@/components/54_chapter55thecataclysm1'
 import A5_CHAPTER56THECATACLYSM2 from '@/components/55_chapter56thecataclysm2'
 import A6_CHAPTER57THREEALLIANCES1 from '@/components/56_chapter57threealliances1'
 import A7_CHAPTER58THREEALLIANCES2 from '@/components/57_chapter58threealliances2'
 import A8_CHAPTER59INSIGHTFULDEFICIENCY1 from '@/components/58_chapter59insightfuldeficiency1'
 import A9_CHAPTER60INSIGHTFULDEFICIENCY2 from '@/components/59_chapter60insightfuldeficiency2'
 import A0_CHAPTER61NETHERPALACES1 from '@/components/60_chapter61netherpalaces1'
 import A1_CHAPTER62NETHERPALACES2 from '@/components/61_chapter62netherpalaces2'
 import A2_CHAPTER63AFFLICTIONI1 from '@/components/62_chapter63afflictioni1'
 import A3_CHAPTER64AFFLICTIONI2 from '@/components/63_chapter64afflictioni2'
 import A4_CHAPTER65AFFLICTIONPARTII1 from '@/components/64_chapter65afflictionpartii1'
 import A5_CHAPTER66AFFLICTIONPARTII2 from '@/components/65_chapter66afflictionpartii2'
 import A6_CHAPTER67AFFLICTIONIII1 from '@/components/66_chapter67afflictioniii1'
 import A7_CHAPTER68AFFLICTIONIII2 from '@/components/67_chapter68afflictioniii2'
 import A8_CHAPTER69VILEAFFECTIONS41 from '@/components/68_chapter69vileaffections41'
 import A9_CHAPTER70VILEAFFECTIONS42 from '@/components/69_chapter70vileaffections42'
 import A0_CHAPTER71AFFLICTION51 from '@/components/70_chapter71affliction51'
 import A1_CHAPTER72AFFLICTION52 from '@/components/71_chapter72affliction52'
 import A2_CHAPTER73AFFLICTION61 from '@/components/72_chapter73affliction61'
 import A3_CHAPTER74AFFLICTION62 from '@/components/73_chapter74affliction62'
 import A4_CHAPTER75AFFLICTION71 from '@/components/74_chapter75affliction71'
 import A5_CHAPTER76AFFLICTION72 from '@/components/75_chapter76affliction72'
 import A6_CHAPTER77AFFLICTION81 from '@/components/76_chapter77affliction81'
 import A7_CHAPTER78AFFLICTION82 from '@/components/77_chapter78affliction82'
 import A8_CHAPTER79INHERITANCEOFTHEICELADY1 from '@/components/78_chapter79inheritanceoftheicelady1'
 import A9_CHAPTER80INHERITANCEOFTHEICELADY2 from '@/components/79_chapter80inheritanceoftheicelady2'
 import A0_CHAPTER81JINYUAN1 from '@/components/80_chapter81jinyuan1'
 import A1_CHAPTER82JINYUAN2 from '@/components/81_chapter82jinyuan2'
 import A2_CHAPTER83THEBATTLEOFJINYUAN11 from '@/components/82_chapter83thebattleofjinyuan11'
 import A3_CHAPTER84THEBATTLEOFJINYUAN12 from '@/components/83_chapter84thebattleofjinyuan12'
 import A4_CHAPTER85THEBATTLEOFJINYUANPARTII1 from '@/components/84_chapter85thebattleofjinyuanpartii1'
 import A5_CHAPTER86THEBATTLEOFJINYUANPARTII2 from '@/components/85_chapter86thebattleofjinyuanpartii2'
 import A6_CHAPTER87SANDALWOODSPIRITBOOK1 from '@/components/86_chapter87sandalwoodspiritbook1'
 import A7_CHAPTER88SANDALWOODSPIRITBOOK2 from '@/components/87_chapter88sandalwoodspiritbook2'
 import A8_CHAPTER89NAMELESSFIELD1 from '@/components/88_chapter89namelessfield1'
 import A9_CHAPTER90NAMELESSFIELD2 from '@/components/89_chapter90namelessfield2'
 import A0_CHAPTER91ENTERNAMELESSDOMAIN1 from '@/components/90_chapter91enternamelessdomain1'
 import A1_CHAPTER92ENTERNAMELESSDOMAIN2 from '@/components/91_chapter92enternamelessdomain2'
 import A2_CHAPTER93BLOODCOLOREDFLOCK1 from '@/components/92_chapter93bloodcoloredflock1'
 import A3_CHAPTER94BLOODCOLOREDFLOCK2 from '@/components/93_chapter94bloodcoloredflock2'
 import A4_CHAPTER95WHITEROCKPRISONER1 from '@/components/94_chapter95whiterockprisoner1'
 import A5_CHAPTER96WHITEROCKPRISONER2 from '@/components/95_chapter96whiterockprisoner2'
 import A6_CHAPTER97PRIMARYSUBSPACE1 from '@/components/96_chapter97primarysubspace1'
 import A7_CHAPTER98PRIMARYSUBSPACE2 from '@/components/97_chapter98primarysubspace2'
 import A8_CHAPTER99ADVICE1 from '@/components/98_chapter99advice1'
 import A9_CHAPTER100ADVICE2 from '@/components/99_chapter100advice2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1longevitylane1",
 			"name" : "0_chapter1longevitylane1",
 			"component" : A_CHAPTER1LONGEVITYLANE1
 		},
 		{
 			"path" : "/1_chapter2longevitylane2",
 			"name" : "1_chapter2longevitylane2",
 			"component" : A_CHAPTER2LONGEVITYLANE2
 		},
 		{
 			"path" : "/2_chapter3sneaker1",
 			"name" : "2_chapter3sneaker1",
 			"component" : A_CHAPTER3SNEAKER1
 		},
 		{
 			"path" : "/3_chapter4sneaker2",
 			"name" : "3_chapter4sneaker2",
 			"component" : A_CHAPTER4SNEAKER2
 		},
 		{
 			"path" : "/4_chapter5homicide1",
 			"name" : "4_chapter5homicide1",
 			"component" : A_CHAPTER5HOMICIDE1
 		},
 		{
 			"path" : "/5_chapter6homicide2",
 			"name" : "5_chapter6homicide2",
 			"component" : A_CHAPTER6HOMICIDE2
 		},
 		{
 			"path" : "/6_chapter7endangered1",
 			"name" : "6_chapter7endangered1",
 			"component" : A_CHAPTER7ENDANGERED1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js